import React from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";

const ValidateStudentRegistrationNo = (RegNo, SchoolID) => {
  if (RegNo === "" || SchoolID == undefined) {
    return { size: 0 };
  }
  if (RegNo && SchoolID) {
    const UserRef = collection(db, "Users");

    const q = query(
      UserRef,
      where("SchoolID", "==", SchoolID),
      where("AdditionalDetails.StudentRegistrationNo", "==", RegNo)
    );

    return getDocs(q).then((querySnapshot) => {
      console.log(querySnapshot.size);
      if (querySnapshot.size) {
        return { size: querySnapshot.size, id: querySnapshot.docs.at(0).id };
      } else {
        return { size: 0, id: "" };
      }
    });
  }
};

export default ValidateStudentRegistrationNo;
